export default {
  '北京': {
    img: `https://static001-test.geekbang.org/resource/image/8c/53/8c1b4ed3909428950538db36b7813153.png`,
    spellName: 'Beijing'
  },
  '成都': {
    img: `https://static001-test.geekbang.org/resource/image/51/30/51a695cfa2c359ff4d43237bdc04e730.png`,
    spellName: 'Chengdu'
  },
  '杭州': {
    img: `https://static001-test.geekbang.org/resource/image/24/6d/243af9fa2663493da70d5b3de872156d.png`,
    spellName: 'Hangzhou'
  },
  '硅谷': {
    img: `https://static001-test.geekbang.org/resource/image/8f/b6/8f429ab7f94a8316045bfeb0e18cb2b6.png`,
    spellName: 'Silicon Valley'
  },
  '南京': {
    img: `https://static001-test.geekbang.org/resource/image/f1/15/f1893378cfdc9a0cb5775b4072255e15.png`,
    spellName: 'Nanjing'
  },
  '广州': {
    img: `https://static001-test.geekbang.org/resource/image/e7/43/e7a9950851bba9c52e2f22e159a1ae43.png`,
    spellName: 'Guangzhou'
  },
  '深圳': {
    img: `https://static001-test.geekbang.org/resource/image/c4/88/c48c7b19fc9e8fae43bf9aebb698cf88.png`,
    spellName: 'Shenzhen'
  },
  '苏州': {
    img: `https://static001-test.geekbang.org/resource/image/e1/93/e1834c1e032a1cf20fcfcdd1aae33293.png`,
    spellName: 'Suzhou'
  },
  '上海': {
    img: `https://static001-test.geekbang.org/resource/image/30/48/3090ae16fb03460c271648f99efc2348.png`,
    spellName: 'Shanghai'
  },
  '厦门': {
    img: `https://static001-test.geekbang.org/resource/image/b7/d2/b7696adf65163ece97de30b0e775c0d2.png`,
    spellName: 'Xiamen'
  },
  '武汉': {
    img: `https://static001-test.geekbang.org/resource/image/ef/2f/ef7cb4771c8a875d4d22d2fc19fa8e2f.png`,
    spellName: 'Wuhan'
  },
  '台北': {
    img: `https://static001-test.geekbang.org/resource/image/15/f9/15dd37304fb0e4a3f4598e66323798f9.png`,
    spellName: 'Taipei'
  }
}
